import React, { Component } from 'react';
import Modal from '../modal';
import { Desktop, Mobile } from '../../app-responsive';
import './business-case-delete-modal.css';
import { customStylesMobile, customStylesDesktop } from './modal-styles-config';

class DeleteModal extends Component {
  onDelete = () => {
    const { businessCaseItem } = this.props;
    this.deleteBusinessCase({ bcbId: businessCaseItem.bcbId });
    this.closeModal();
  };
  closeModal = this.props.closeModal;
  deleteBusinessCase = this.props.deleteBusinessCase;
  render() {
    const { deleteButtonText, modalIsOpen } = this.props;
    const modalContent = customStyles => (
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={this.closeModal}
        style={customStyles}
      >
        <div className="delete-business-case-modal">
          <p>{deleteButtonText}</p>
          <button onClick={this.closeModal}>No</button>
          <button onClick={this.onDelete}>Yes</button>
        </div>
      </Modal>
    );
    return (
      <React.Fragment>
        <Mobile>
          {modalContent(customStylesMobile)}
        </Mobile>
        <Desktop>
          {modalContent(customStylesDesktop)}
        </Desktop>
      </React.Fragment>
    );
  }
}

export default DeleteModal;
